<template>
  <!-- 优惠券下发 -->
  <div class="giveOut">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['优惠券', $route.meta.title]"
    >
      <template slot="controls">
        <el-link
          icon="el-icon-question"
          type="primary"
          :href="baseUrl + '/UploadFile/Template/优惠券下发模板.xls'"
          target="_blank"
          >下载模板</el-link
        >

        <el-button type="danger" @click="handleDel()" v-if="buttonVisibility.delete">删除</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">设备类型：</label>
        <el-select
          placeholder="设备类型"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.deviceType"
        >
          <el-option label="全部" value="99"></el-option>
          <el-option label="通用" value="10006"></el-option>
          <el-option label="电脑端" value="10000"></el-option>
          <el-option label="苹果" value="10005"></el-option>
          <el-option label="安卓" value="10003"></el-option>
        </el-select>
        <label class="label">规则范围：</label>
        <el-select
          placeholder="规则范围"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.range"
        >
          <el-option label="全部" value="99"></el-option>
          <el-option label="全部商品" value="0"></el-option>
          <el-option label="分类商品" value="1"></el-option>
          <el-option label="品牌商品" value="2"></el-option>
          <el-option label="独立商品" value="3"></el-option>
        </el-select>
        <label class="label">规则类型：</label>
        <el-select
          placeholder="规则类型"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.ruleType"
        >
          <el-option label="全部" value="99"></el-option>
          <el-option label="无门槛" value="0"></el-option>
          <el-option label="满减" value="1"></el-option>
        </el-select>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入名称"
          v-model="searchForm.name"
        ></el-input>
        <el-button 
          type="primary" 
          v-if="buttonVisibility.search"
          @click="seach" 
          icon="el-icon-search"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      @selection-change="selectionChangeTable"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="couponCode"
        show-overflow-tooltip
        label="优惠券编码"
      >
      </el-table-column>
      <el-table-column
        prop="couponName"
        align="center"
        show-overflow-tooltip
        label="优惠券名称"
      >
      </el-table-column>
      <el-table-column
        prop="couponsNumber"
        label="优惠券数量"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="typetitle"
        label="领取类型"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.receivingType }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="sceneName"
        label="领取类型"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column> -->
      <el-table-column
        prop="SceneSon"
        label="范围类型"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="SceneSon"
        label="范围"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="coupontype"
        label="优惠类型"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="startingTime"
        label="开始时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="endTime"
        label="结束时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" width="160" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            style="padding: 2px 3px"
            v-if="buttonVisibility.view"
            plain
            @click="couponDetail(scope.row)"
            >查看</el-button
          >
          <el-button
            type="warning"
            style="padding: 2px 3px"
            v-if="buttonVisibility.grant"
            plain
            @click="grantCoupon(scope.row)"
            >下发</el-button
          >
          <!-- <el-button
            type="warning"
            v-if="scope.row.receivingType == '业务员优惠券'"
            style="padding: 2px 3px"
            plain
            @click="grantYewu(scope.row)"
            >下发</el-button
          > -->
          <el-button
            type="primary"
            style="margin-left: 10px; padding: 2px 3px"
            v-if="buttonVisibility.import"
            plain
            @click="dropdownCommand(scope.row)"
            >导入数据</el-button
          >
          <!-- <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 2)"
            >删除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <!-- 客户列表 -->
    <el-dialog title="客户列表" :visible.sync="dialogVisible" width="70%">
      <search-bar>
        <template>
          <el-input
            style="width: 200px; margin-right: 5px"
            clearable
            placeholder="输入编号/名称"
            v-model="searchForm1.name"
          ></el-input>
          <el-button type="primary" icon="el-icon-search" @click="seach1"
            >搜索</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-circle-check"
            @click="detarRegion"
            >确定</el-button
          >
        </template>
      </search-bar>
      <el-table
        :data="userList"
        stripe
        border
        tooltip-effect="dark"
        @row-dblclick="rowClick"
        @selection-change="selectionChange"
        style="width: 100%; height: 100%; overflow: auto"
      >
        <el-table-column type="selection" align="center" width="55">
        </el-table-column>
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ (currPage1 - 1) * pageSize1 + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column type="selection" align="center" width="55">
        </el-table-column>
        <el-table-column
          align="center"
          prop="businesscode"
          show-overflow-tooltip
          label="用户名"
        >
        </el-table-column>
        <el-table-column
          prop="businesscode"
          align="center"
          show-overflow-tooltip
          label="单位编号"
        >
        </el-table-column>
        <el-table-column
          prop="businessname"
          label="单位名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="clienttype"
          label="客户类型"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="订单数"
          label="订单数"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :allPage="allPage1"
        :pageSize="pageSize1"
        :currIndex="currPage1"
        @hanCurrChange="hanCurrChange1"
        layout="total, prev, pager, next, jumper"
      ></pagination>
    </el-dialog>

    <!-- 业务员列表 -->
    <el-dialog title="业务员列表" :visible.sync="salesVisible" width="70%">
      <search-bar>
        <template>
          <el-input
            style="width: 200px; margin-right: 5px"
            clearable
            placeholder="输入编号/名称"
            v-model="searchForm2.name"
          ></el-input>
          <el-button type="primary" icon="el-icon-search" @click="seach2"
            >搜索</el-button
          >
          <!-- <el-button
            type="primary"
            icon="el-icon-circle-check"
            @click="salesRegion"
            >确定</el-button
          > -->
        </template>
      </search-bar>
      <el-table
        :data="salesList"
        stripe
        border
        tooltip-effect="dark"
        style="width: 100%; height: 100%; overflow: auto"
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ (currPage1 - 1) * pageSize1 + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="Name"
          label="用户名"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="TelPhone"
          label="手机号"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="RoleName"
          label="角色名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="RoleName"
          label="操作"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-button type="primary"
             @click="salesRegion(scope.row)"
              >选择</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :allPage="allPage2"
        :pageSize="pageSize2"
        :currIndex="currPage2"
        @hanCurrChange="hanCurrChange2"
        layout="total, prev, pager, next, jumper"
      ></pagination>
    </el-dialog>

    <!-- accept="image/jpg,image/jpeg,image/png" -->
    <upload
      ref="upload"
      style="display: none"
      @fileChange="uploadGoods"
      :multiple="true"
    ></upload>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: "giveOut",
  data() {
    return {
      /**表格数据 */
      //序号	操作	优惠券编码	优惠券名称	优惠券数量
      //渠道类型	领取类型	范围类型	范围	优惠类型	开始时间	结束时间
      tableData: [
        {
          code: "优惠券编码",
          name: "优惠券数量",
          num: "优惠券数量",
          deviceType: "渠道类型",
          getType: "领取类型",
          rangeType: "范围类型",
          range: "范围",
          couponType: "优惠类型",
          start: "开始时间",
          end: "结束时间",
        },
      ],
      /**搜索表单 */
      //设备类型 规则范围 规则类型 优惠券名称
      searchForm: {
        deviceType: "99",
        range: "99",
        ruleType: "99",
        name: "",
      },
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      couponId: "",
      selectionTable: [],
      // 会员列表
      userList: [],
      userListData: [],
      searchForm1: {
        name: "",
      },
      dialogVisible: false,
      /**分页数据 */
      currPage1: 1,
      pageSize1: 10,
      allPage1: 0,

      // 优惠券下发业务员模块
      salesVisible: false,
      searchForm2: {
        name: "",
      },
      salesChangeData: {},
      couponNum: 0,
      salesList: [],
      /**分页数据 */
      currPage2: 1,
      pageSize2: 10,
      allPage2: 0,
      couponCode: "",
    };
  },
  computed: {
    ...mapState(['buttonPermissions']),
    buttonVisibility() {
      const buttonsLimit = this.buttonPermissions?.['优惠券下发'] || [] 
      // console.log('buttonsLimit', buttonsLimit);
      return {
        delete: buttonsLimit.includes('删除'),
        search: buttonsLimit.includes('搜索'),
        view: buttonsLimit.includes('查看'),
        grant: buttonsLimit.includes('下发'),
        import: buttonsLimit.includes('导入数据'),
      }
    } 
  },
  components: {},
  mounted() {
    this.getTableData();
  },
  methods: {
    seach() {
      this.getTableData(1);
    },
    dropdownCommand(row) {
      console.log(row, "2323");
      this.couponCode = row.couponCode;
      this.$refs.upload.handleClick();
    },
    // 商品详情图片上传回调
    uploadGoods(file) {
      file = file.slice(0, 200); //最多可选择200张，多余的将会截断
      if (file.length) {
        let fileData = new FormData();
        for (let i = 0; i < file.length; i++) {
          fileData.append("FileNmaes", file[i]);
        }
        this.$uploadRequest({
          url:
            "/Management/CouponAdmin/IssueCouponsToExcel?couponCode=" +
            this.couponCode,
          method: "post",
          data: fileData,
        })
          .then((res) => {
            console.log(res);
            if (res.flag == 0) {
              this.$confirm(res.message + "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {});
            } else {
              this.$confirm(res.message + "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {});
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      }
    },
    /**获取表格数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "Pc_GetXFCoupon",
        couponCode: this.searchForm.name,
        couponName: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
        sltGZ: this.searchForm.ruleType,
        sltSB: this.searchForm.deviceType,
        sltCJ: this.searchForm.range,
      };
      let proc = "Pc_Coupon"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "coupon/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          this.tableData = [];
          if (res.flag == 0) {
            this.tableData = res.data;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 查看优惠券详情
    couponDetail(row) {
      let prams = null;
      if (row) {
        prams = encodeURIComponent(
          JSON.stringify({ couponId: row.couponCode })
        );
      } else {
        prams = row;
      }
      this.$router.push({
        path: "couponDetail",
        query: {
          prams: prams,
        },
      });
      prams = null;
    },
    // 存放选中的数据
    selectionChangeTable(section) {
      this.selectionTable = section;
    },
    /**删除 */
    handleDel() {
      let row = {};
      if (this.selectionTable.length == 1) {
        row = this.selectionTable[0];
        this.changeStatus(row, 2);
      } else {
        this.$message({
          message: "只能删除一条数据",
          type: "warning",
        });
      }
    },
    // 修改优惠券状态
    changeStatus(row, status) {
      let msg = "确定要执行操作吗?";
      let type = "info";
      if (status == 0) {
        msg = "确定下架吗?";
        type = "warning";
      } else if (status == 1) {
        msg = "确定上架吗?";
        type = "success";
      } else if (status == 2) {
        msg = "确定删除吗?";
        type = "error";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          let data = {
            type: "PC_UpStatusCoupon",
            couponCode: row.couponCode,
            status: status,
          };
          let proc = "Pc_Coupon"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "coupon/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    grantCoupon(row) {
      this.couponId = row.couponCode;
      this.getUserData();
    },
    // 获取用户数据
    getUserData() {
      let data = {
        type: "GetCouponsDistributed",
        couponCode: this.couponId,
        startTime: "",
        endTime: "",
        orderFrequency: "",
        sqlValue: this.searchForm1.name,
        pageIndex: this.currPage1,
        pageSize: this.pageSize1,
      };
      let proc = "Proc_MemberCoupon"; //存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          encodeURIComponent(type) +
          "&proc=" +
          encodeURIComponent(proc),
      })
        .then((res) => {
          this.userList = [];
          if (res.flag == 0) {
            this.userList = res.content;
            this.allPage1 = res.recordCount;
            this.dialogVisible = true;
          } else {
            this.$message({
              message: res.message,
              type: "waning",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    seach1() {
      this.getUserData();
    },
    // 存放选中的数据
    selectionChange(section) {
      this.userListData = section;
    },
    // 行选中事件
    rowClick(row) {
      this.saveCouponUser(row.keyid);
    },
    // 多选确定功能
    detarRegion() {
      let id = this.userListData.map((item) => item.keyid).join(",");
      this.saveCouponUser(id);
    },
    // 下发优惠券保存
    saveCouponUser(id) {
      let data = {
        type: "SaveUserCouponList",
        couponcodes: this.couponId,
        userfabh: id,
      };
      let proc = "Proc_UserInfo"; //存储过程名
      let type = "ReturnNumber";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getTableData();
            this.dialogVisible = false;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**当前页改变 */
    hanCurrChange1(val) {
      this.currPage1 = val;
      this.getUserData();
    },
    // 关闭会员选择弹窗
    handleClose() {
      this.dialogVisible = false;
    }, // 导出数据
    exportData() {
      window.location.href =
        this.baseUrl + "Management/CouponAdmin/IssueCouponsToExcel";
    },
    // 优惠券下发业务员
    grantYewu(row) {
      console.log(row, "12321");
      this.couponId = row.couponCode;
      this.couponNum = row.couponsNumber;
      this.getYewuData();
    },
    seach2() {
      this.getYewuData();
    },
    /**获取数据 */
    getYewuData(num) {
      this.currPage = num == 1 ? 1 : this.currPage2;
      let data = {
        valStr: this.searchForm2.name,
        pageInde: this.currPage2,
        department: "业务员",
        pageSize: this.pageSize2,
      };
      this.$request({
        url: "/Management/SalesManAdmin/GetSalesManList",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.salesList = res.dataList;
            this.allPage2 = res.recordCount;
            this.salesVisible = true;
          } else {
            //失败提示
            this.$message({
              message: res.message,
              type: "error",
            });
            this.allPage2 = 0;
          }
        })
        .catch((err) => {
          window.console.log(err);
          this.allPage = 0;
        });
    },
    /**分页size改变 */
    hanSiChange2(val) {
      this.pageSize2 = val;
      this.getYewuData();
    },
    /**当前页改变 */
    hanCurrChange2(val) {
      this.currPage2 = val;
      this.getYewuData();
    },

    // 业务员确定下发
    salesRegion(row) {
      this.salesChangeData = row;
      this.$prompt("请输入下发数量", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (value > this.couponNum) {
            this.$message({
              type: "warning",
              message:
                "下发数量不能大于优惠券总数量" + this.couponNum + "请输入",
            });
          } else {
            this.salesCouponUser(value);
          }
        })
        .catch(() => {
          this.couponNum = "";
          this.salesChangeData = {};
          this.salesVisible = false;
        });
    },
    salesCouponUser(id) {
      let data = {
        salesManId: this.salesChangeData.UserId,
        couponCode: this.couponId,
        couponNum: id,
      };
      this.$request({
        method: "post",
        url: "/Management/CouponAdmin/IssueSalesManCoupons",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getTableData();
            this.couponNum = "";
            this.salesChangeData = {};
            this.salesVisible = false;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.giveOut {
  width: 100%;
  height: 100%;
}
.couponView {
  width: 100%;
  height: 100%;
  list-style: none;
}
.couponView > li {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  list-style: none;
}
.couponTitle {
  display: inline-block;
  height: 40px;
  margin-right: 5px;
  font-size: 16px;
  color: #000;
  line-height: 40px;
}
.couponText {
  display: inline-block;
  height: 40px;
  margin-right: 5px;
  font-size: 16px;
  color: #ccc;
  line-height: 40px;
}
</style>
